<details-page-layout title="Managed user detail">
  <!-- <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Managed user detail'"></page-title>
    </div>

    <a mat-stroked-button routerLink="/user-management/users">Back to list</a>
  </div> -->
 @if (userStore.selectedUser(); as currentUser) {
    <div class="col-span-1 lg:col-span-2 overflow-auto pb-1">
      <app-user-info
        [title]="'User details'"
        [user]="currentUser"
      />
    </div>
      @if (canUpdate()) {
        <div class="col-span-1 lg:col-span-2 h-full overflow-auto pb-1">
          <update-user
            [title]="'Edit managed user'"
            [submitLabel]="'Save user'"
            [includeAssignments]="true"
            [busy]="userStore.saving()"
            [clients]="clientStore.clients()"
            [portals]="lookupStore.portals()"
            [userRoles]="lookupStore.userRoles()"
            [affiliateOptions]="affiliateOptions()"
            [affiliateOptionsLoading]="affiliateStore.affiliateLookupLoading()"
            [initialValue]="currentUser"
            (submitted)="saveUser($event)"
            (affiliateSearchChanged)="affiliateSearchChanged($event)">
           @if ((currentUser.isActive && canDeactivate()) || (!currentUser.isActive && canActivate())) {
              <div class="flex justify-end gap-2">
                <button
                  matButton="filled"
                  class="mom-danger"
                  type="button"
                  [disabled]="userStore.activating() || userStore.deactivating()"
                  (click)="toggleUserActive(currentUser)">
                  @if (userStore.activating() || userStore.deactivating()) {
                    <mat-spinner diameter="20" class="mr-2" />
                  }
                  {{ currentUser.isActive ? 'Deactivate' : 'Activate' }}
                </button>
              </div>  
            }
          </update-user>
      </div>
      }
    <div class="col-span-1 lg:col-span-2 xl:col-span-4 overflow-auto">
      <user-history [history]="userStore.history()" />
    </div>
  } @else {
    <mat-card class="p-5">
      @if (userStore.loading()) {
        <div class="flex items-center gap-3 text-sm">
          <mat-spinner diameter="24" />
          Loading user data...
        </div>
      } @else {
        <p class="text-sm">User data was not found.</p>
      }
    </mat-card>
  }
</details-page-layout>